import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'components/Form/Checkbox';
import Button from 'components/Button';
import ANALYTICS from 'constants/analytics';
import THEMES from 'constants/themes';
import { i18n } from 'utils/i18n';
import { capitalizeAll } from 'utils/string';
import { analyticsInteraction } from 'utils/analytics';
import { Form } from 'react-final-form';
import utils from '@ehi/global-marketing-interface/lib/utils';

const VehicleClassFilterModalContent = ({ vehicleCategories, handleSetVehicleState, handleCheckboxChange }) => {
  const onSubmit = () => {};

  const handleSelectAll = (index, category) => {
    handleSetVehicleState(vehicleCategories, index);
    analyticsInteraction(
      ANALYTICS.FILTER,
      i18n('search_vehicle_class'),
      `${capitalizeAll(ANALYTICS.SELECT_ALL)} ${category}`
    );
  };

  const handleCheckbox = (value, carIndex, subcategory_code) => (e, input, checked) => {
    const vehicleData = vehicleCategories;
    let vehicles = [...vehicleData[carIndex].vehicles];

    // updating select all for vehicle class false when user makes changes to his select all classes
    if (vehicleData[carIndex].carClassChecked) {
      vehicleData[carIndex].carClassChecked = false;
    }

    vehicles = vehicles.map((item) => ({
      ...item,
      checked: item.subcategory_code === subcategory_code ? checked : item.checked,
    }));
    vehicleData[carIndex] = { ...vehicleData[carIndex], vehicles };
    handleCheckboxChange(vehicleData);
    const classesSelected = [...vehicles];
    classesSelected.filter((item) => item.checked).map((vehicle) => vehicle.name);
    analyticsInteraction(ANALYTICS.FILTER, `${value}`, checked ? `Added ${value}` : `Removed ${value}`);
  };

  return (
    <div className='vehicle-filters'>
      {!!vehicleCategories &&
        vehicleCategories.map((category, index) => {
          const { vehicles } = category;
          const uniqueSet = new Set();
          const filteredVehicles = vehicles.filter((vehicle) => {
            const isUniqueCode = uniqueSet.has(vehicle.category.subcategories[0].subcategory_code);
            uniqueSet.add(vehicle.category.subcategories?.[0].subcategory_code);
            return !isUniqueCode;
          });

          if (utils.isArrayNotEmpty(vehicles)) {
            return (
              <Form key={index} onSubmit={onSubmit}>
                {({ handleSubmit }) => (
                  <form className='searchby-vehicle-modal__form' onSubmit={handleSubmit}>
                    <fieldset className='vehicle-filters__grid'>
                      <div className='vehicle-filters__header-row-container'>
                        <legend className='vehicle-filters__header-row-container--label'>{category.label}</legend>
                        <Button
                          plain
                          className='vehicle-filters__header-row-container--select-all-button'
                          type='button'
                          onClick={() => handleSelectAll(index, category.label)}
                          aria-label={`${i18n('common_select_all')} ${category.label}`}
                        >
                          {' '}
                          {i18n('common_select_all')}
                        </Button>
                      </div>
                      {filteredVehicles?.map(({ checked, name, subcategory_code }, keyIndex) => (
                        <Checkbox
                          key={keyIndex}
                          keyIndex={keyIndex}
                          carIndex={index}
                          checked={checked}
                          label={name}
                          name='checkbox_select'
                          theme={THEMES.LIGHT}
                          onChange={handleCheckbox(name, index, subcategory_code)}
                        />
                      ))}
                    </fieldset>
                  </form>
                )}
              </Form>
            );
          }
          return null;
        })}
    </div>
  );
};

VehicleClassFilterModalContent.propTypes = {
  vehicleCategories: PropTypes.array,
};

export default VehicleClassFilterModalContent;
